// 字典数据映射
export const DICT_KEY = {
  brand: "storeroom_brand", // 品牌
  model: "storeroom_model", // 规格型号
  boundTypeIn: "storeroom_bound_type_in", // 入库类型
  boundTypeOut: "storeroom_bound_type_out", // 出库类型
  supplierType: "storeroom_supplier_type", // 供应商类型
  boundAcceptMaterial: "storeroom_bound_accept_material",
  storeroom_project_type: "storeroom_project_type",
};
